import React, {useState} from 'react';
import { Linkedin, Github, Instagram, Mail} from 'lucide-react'; // Importing icons from lucide-react

const socialLinks = [
  { name: 'Email', text:"emanuela.gonzales@gmail.com", url: 'mailto:emanuela.gonzales98@gmail.com', icon: <Mail size={40}  /> },
  { name: 'LinkedIn', text:"",url: 'https://www.linkedin.com/in/emanuelagonzales/', icon: <Linkedin size={40}  /> },
  { name: 'GitHub', text:"",url: 'https://github.com/Emagonzales', icon: <Github size={40} /> },
  { name: 'Instagram', text:"",url: 'https://www.instagram.com/tiramisu.code/', icon: <Instagram size={40} /> },
];

const Contact = () => {
  const [email, setEmail] = useState('');

  const isEmailValid = (email) => {
    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <section className="contact-section" id="contactme">
      <h1 className='title'>&lt; ContactMe /&gt;</h1>
      <div className='main-container'>
        <div className='flex'>
          <div className='w-50 glass-box'>
            <form name="contact"
              method="POST"
              data-netlify="true"
              netlify-honeypot="bot-field"
              className="contact-form">
                <input type="hidden" name="form-name" value="contact" />
                <input type="hidden" name="bot-field" />

                <div className="field">
                    <label>Email</label>
                    <input aria-label="Email" type="email" name="email" value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required />
                    {!isEmailValid(email) && email !== '' && (
                      <small className="error">Please enter a valid email address.</small>
                    )}
                </div>
                <div className="field">
                    <label>Name</label>
                    <input aria-label="Name" type="text" name="name" />
                </div>
            
                <div className="field">
                    <label>Message</label>
                    <textarea aria-label="Message" name="message"></textarea>
                </div>
              <button className={`btn ${!isEmailValid(email) ? 'btn-disabled' : ''}`}  type="submit" disabled={!isEmailValid(email)}>SEND ME A MESSAGE</button>
            </form>
          </div>
          <div className="social-links">
            {socialLinks.map((social, index) => (
              <a key={index} href={social.url} target="_blank" rel="noopener noreferrer" aria-label="Social link" className="social-link">
                {social.icon}
                <span className="social-name">{social.name} {social.text && <small>({social.text})</small>}</span>
              </a>
              
            ))}
          </div>
        </div>
      </div>
      
    </section>
  );
};

export default Contact;